import { render, staticRenderFns } from "./PcsAuthLogin.vue?vue&type=template&id=202165f5&scoped=true"
import script from "./PcsAuthLogin.vue?vue&type=script&lang=js"
export * from "./PcsAuthLogin.vue?vue&type=script&lang=js"
import style0 from "./PcsAuthLogin.vue?vue&type=style&index=0&id=202165f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202165f5",
  null
  
)

export default component.exports